import component from './developers.component';
import route from './developers.routes';

angular.module('rym.developers', []).component('rymDevelopers', component).run(route);
